import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root',
})
export class ProcessControlService {
  
get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) {}

  async getParameterProcessControl(data: any): Promise<any> {
    return await this.http
      .post<any>(this.O3CoreApiUrl + 'Quality/ProcessControl', data)
      .toPromise();
  }
  // async getProcessControl(data: any): Promise<any> {
  //   // return await this.http
  //   //   .post<any>(this.baseUrl + 'getProcessControl', data)
  //   //   .toPromise();

  //   return await this.http.post<any>(this.O3CoreApiUrl + 'qualityProcess/getProcessControl', data).toPromise();
  // }
  saveProessControl(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any>(
      this.O3CoreApiUrl + 'Quality/SaveProcessControl',
      data,
      {
        headers: header,
      }
    );
  }
  getProcessParameterAnalysis(data: any): Promise<any> {
    return this.http
      .post<any>(this.O3CoreApiUrl + 'ProcessControl/AnalysisChart', data)
      .toPromise();
  }
  async getQualityProcessControl(data: any): Promise<any> {
    return await this.http
      .post<any>(this.O3CoreApiUrl + 'Quality/QualityProcessControl', data)
      .toPromise();
  }
  saveQualityProcessControl(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any>(
      this.O3CoreApiUrl + 'Quality/SaveQualityProcessControl',
      data,
      { headers: header }
    );
  }
  async getQualityProcessParameterAnalysis(data: any): Promise<any> {
    return await this.http
      .post<any>(this.O3CoreApiUrl + 'QualityParameter/AnalysisChart', data)
      .toPromise();
  }
  async getQualityProcessParameterComparison(data: any): Promise<any> {
    // return await this.http
    //   .post<any>(this.baseUrl + 'getQualityProcessParameterComparison', data)
    //   .toPromise();
    return await this.http
      .post<any>(
        this.O3CoreApiUrl +
          'QualityProcess/getQualityProcessParameterComparison',
        data
      )
      .toPromise();
  }
  async getParameterControlComparison(data: any): Promise<any> {
    return await this.http
      .post<any>(this.O3CoreApiUrl + 'ProcessControl/ComparisonChart', data)
      .toPromise();
  }
  processparamaterdefects(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // return this.http.post<any>(this.baseUrl + 'processparamaterdefects', data, {headers: header,
    return this.http.post<any>(
      this.O3CoreApiUrl + 'ProcessControl/GetProcessParamaterDefects',
      data,
      { headers: header }
    );
  }
  processparameterspecs(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // return this.http.post<any>(this.baseUrl + 'processparameterspecs', data, {headers: header,
    return this.http.post<any>(
      this.O3CoreApiUrl + 'ProcessControl/GetProcessParameterSpecs',
      data,
      {
        headers: header,
      }
    );
  }
  getQualityControlProcessOrder(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any>(
      this.O3CoreApiUrl + 'QualityProcess/getQualityControlProcessOrder',
      data,
      { headers: header }
    );
  }
  getMachineParameterProcessType(data: any): any {
    return this.http.post<any>(
      this.O3CoreApiUrl + 'QualityProcess/getMachineParameterProcessType',
      data
    );
  }
  getProcessControlInterval(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'QualityParam/GetProcessControlInterval',
      data
    );
  }
  getQualityGroupEvents(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'QualityProcess/getQualityGroupEvents',
      data
    );
  }
  getVariableGroupEvents(data: any): Observable<any[]> {
    // return this.http.post<any[]>(this.baseUrl + 'getVariableGroupEvents', data);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'ProcessControl/GetVariableGroupEvents', data);
  
  }
  getParamterGroupList(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'QualityParameter/getParamterGroupList',
      data
    );
  }
  getMachineProducts(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'QualityParameter/GetMachineProducts',
      data
    );
  }
}
